import { cardLinkApiClient } from '@/src/card-linking/api-client/cardLinkApiClient'

const postEnrollCard = async (payload: any) => {
    console.log('postEnrollCard initial payload', payload)

    const updatedPayload = {
        name: payload?.name,
        account_number: payload?.card_number.replace(/\D/g, ''),
        card_expiration: payload?.card_expiration,
        type: payload?.type,
    }
    console.log('postEnrollCard updatedPayload', updatedPayload)

    const { data } = await cardLinkApiClient.post(
        `/partner-card-link/${process.env.NEXT_PUBLIC_CARD_LINK_COMPANY_ID}/card-link-session/enrolled-cards`,
        updatedPayload,
        {
            headers: {
                'Card-Link-Session-ID': payload?.card_link_session_id,
            },
        }
    )
    return data
}

export default postEnrollCard
